import { Link } from 'react-router-dom'
import { BadgeCheck, Languages, MessageCircle, Phone, Star } from 'lucide-react'
import type { Astrologer, Language } from '../types'

function Avatar({ astrologer }: { astrologer: Astrologer }) {
  return astrologer.photo
    ? <img className="astro-photo" src={astrologer.photo} alt={astrologer.name} />
    : <div className="astro-photo astro-initials"><span>{astrologer.name.split(' ').map((part) => part[0]).join('').slice(0, 2)}</span></div>
}

export function AstrologerCard({ language, astrologer, preview = false }: { language: Language; astrologer: Astrologer; preview?: boolean }) {
  const en = language === 'en'
  return <article className="astro-card">
    {preview && <span className="preview-label">PREVIEW PROFILE</span>}
    <div className="astro-top">
      <div className="photo-wrap"><Avatar astrologer={astrologer} />{astrologer.online && <span className="online-dot" />}</div>
      <div className="astro-main">
        <div className="name-line"><h3>{astrologer.name}</h3>{astrologer.verified && <BadgeCheck size={18} />}</div>
        <p>{astrologer.title}</p>
        <div className="rating"><Star size={15} fill="currentColor" /> {astrologer.rating} <span>({astrologer.reviews.toLocaleString('en-IN')})</span></div>
      </div>
    </div>
    <div className="astro-meta"><span>{astrologer.experience}+ {en ? 'years experience' : 'वर्ष अनुभव'}</span><span><Languages size={14} /> {astrologer.languages.join(', ')}</span></div>
    <div className="skill-list">{astrologer.skills.slice(0, 3).map((skill) => <span key={skill}>{skill}</span>)}</div>
    <div className="availability"><span className={astrologer.online ? 'is-online' : ''}>{astrologer.online ? '● Online' : '○ Offline'}</span><span>{en && astrologer.online ? 'Available now' : astrologer.nextAvailable}</span></div>
    <div className="price-row"><div><small>Call</small><strong>₹{astrologer.priceCall}/min</strong></div><div><small>Chat</small><strong>₹{astrologer.priceChat}/min</strong></div></div>
    <div className="card-actions"><Link className="outline-button" to={`/astrologers/${astrologer.id}?mode=chat`}><MessageCircle size={17} /> Chat</Link><Link className="primary-button" to={`/astrologers/${astrologer.id}?mode=call`}><Phone size={17} /> {en ? 'Call now' : 'Call करें'}</Link></div>
  </article>
}
